/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_UsInputs */

const en_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Us`)
};

const th_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับเรา`)
};

const ja_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社概要`)
};

const fr_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const es_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre nosotros`)
};

const ru_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас`)
};

const zh_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于我们`)
};

const vi_about_us = /** @type {(inputs: About_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về chúng tôi`)
};

/**
* | output |
* | --- |
* | "About Us" |
*
* @param {About_UsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const about_us = /** @type {((inputs?: About_UsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_UsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_about_us(inputs)
	if (locale === "ja") return ja_about_us(inputs)
	if (locale === "fr") return fr_about_us(inputs)
	if (locale === "es") return es_about_us(inputs)
	if (locale === "ru") return ru_about_us(inputs)
	if (locale === "zh") return zh_about_us(inputs)
	if (locale === "vi") return vi_about_us(inputs)
	return en_about_us(inputs)
});